import BaseService from '@/services/BaseService'

class GrupoFinanceiroService extends BaseService {
    constructor(){
        super('/v1/grupos-financeiro')
    }
}

export default new GrupoFinanceiroService